import { css } from 'styled-components';
import { CardSectionHeading } from '../../../../../components/Header/DoubleHeader/CardSection/styles';
import {
  BottomBurgerLine,
  MiddleBurgerLine,
  TopBurgerLine,
} from '../../../../../components/Header/NavMobile/BurgerMenuIcon/styles';
import {
  SectionHeading,
  SectionLink,
} from '../../../../../components/Header/NavMobile/Menus/LinkSections/styles';
import { SimplePrimaryNavSubmenuHeading } from '../../../../../components/Header/NavMobile/Menus/styles';
import {
  MenuContainer,
  TertiaryNavIconBackground,
  TertiaryNavItemDark,
  TertiaryNavItemHeading,
} from '../../../../../components/Header/NavMobile/styles';
import { GridAlignedText } from '../../../../../components/Header/commonStyles/commonHeaderStyles';
import { IconWrapper } from '../../../../../components/Icon/styles';
import mediaQuery from '../../../../../helpers/mediaQuery';
import spacing from '../../../../../helpers/spacing';
import { colors, themeSpecificColors } from '../../../colors';
import { headerBoxShadowStyle } from '../../../helpers/commonStyles';
import { layout } from '../../../layout';

export default css`
  ${MenuContainer} {
    ${headerBoxShadowStyle}
  }

  ${SimplePrimaryNavSubmenuHeading} {
    background-color: ${colors.core02};
    color: ${colors.neutral08};
    padding-top: ${spacing(3)};
    padding-bottom: ${spacing(3)};

    ${IconWrapper} {
      padding-left: 0;
    }

    svg {
      fill: ${colors.neutral08};
    }

    &:not(:first-of-type) {
      padding-top: ${spacing(3)};
  }
  }

  ${SectionHeading} {
    color: ${colors.core01};
    padding: ${spacing(2)};
  }

  ${SectionLink} {
    background-color: ${colors.core03};
    color: ${colors.neutral08};
  }

  && {
    ${TertiaryNavItemDark}, ${TertiaryNavItemHeading} {
      background-color: ${colors.neutral08};
      color: ${colors.core01};

      svg {
        fill: ${colors.core01};
      }

      ${GridAlignedText} {
        justify-content: flex-start;
      }
    }
  }

  ${CardSectionHeading} {
    font-weight: 700;
    line-height: 1.75rem;
  }

  ${GridAlignedText} {
    font-weight: 400;
    font-size: 1.25rem;

    padding: 0;
    max-width: ${layout.mobile.containerWidthPx}px;

    ${mediaQuery.tabletPortrait`
      max-width: 100%;
    `}
  }

  ${TertiaryNavIconBackground} {
    background-color: ${themeSpecificColors.core03_10};

    ${IconWrapper} {
      height: ${spacing(2.5)};
      width: ${spacing(2.5)};
    }
  }

  && {
      ${TopBurgerLine}, ${MiddleBurgerLine}, ${BottomBurgerLine} {
      border-radius: 0;
      background: ${themeSpecificColors.core06};
    }
  }
`;
